import type { HelpFile } from '../../types/help'
import { ExecutionLogViewerTestIds } from '../../../testids/ExecutionLogViewerTestIds'

export const executionLogViewerHelp: HelpFile = {
  docPage: '/docs/jobs/execution-logs',
  texts: {
    [ExecutionLogViewerTestIds.btnDownloadLogs]:
      'Vollständiges Ausführungsprotokoll als Textdatei herunterladen — hilfreich für die Analyse offline oder zum Weitergeben.',
  },
}
